import { render, staticRenderFns } from "./relatedVendor.vue?vue&type=template&id=5478ce23&scoped=true&"
import script from "./relatedVendor.vue?vue&type=script&lang=js&"
export * from "./relatedVendor.vue?vue&type=script&lang=js&"
import style0 from "./relatedVendor.vue?vue&type=style&index=0&id=5478ce23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478ce23",
  null
  
)

export default component.exports